// extracted by extract-css-chunks-webpack-plugin
module.exports = {"user-card-image":"user-card-image","content":"content","user-options":"user-options","ar-rule":"ar-rule","ar-title":"ar-title","details":"details"};